<template>
  <div class="how-buy">
    <div class="ha-des">      
      <!-- <p class="black">问：没有激活码，如何购买可瀚学堂？</p> -->
      <!-- 点击进入网页购买课程，下单后我们会为您寄送激活码和配套绘本。<br>
        网址：<a href="https://www.kehigh.com/buy">https://www.kehigh.com/buy</a> -->
      <p class="black">情景式智能化英语课程体系——可瀚学堂之伊索寓言</p>
      <p>可瀚学堂精选90个古希腊《伊索寓言》故事加以改编，制作精美的动画，配套绘本、APP软件等相关资料，目前已开发完成30个。课程内容分为初、中、高级，每个等级5个故事为一个学习彩盒套装。彩盒套装内激活卡可以激活APP内相应的在线动画课程。</p>
      <p>点击下方链接，了解学习彩盒内容。</p>
      <p><a href="https://mp.weixin.qq.com/s/HeDnEijvGoZ5WF2KWJyuqg">https://mp.weixin.qq.com/s/HeDnEijvGoZ5WF2KWJyuqg</a></p>
      <p>购买请联系客服</p>
      <p>微信客服：kehigh001（9:00-22:00）</p>
      <p>邮箱：business@kehigh.com</p>
      <p>电话：17796327580 （周一~周五，9:00~18:00）</p>      
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-buy {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = '如何购买课程? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何购买课程')
    },
    components: {}
  }
</script>
